import { render, staticRenderFns } from "./datails.vue?vue&type=template&id=5c989f28&scoped=true&"
import script from "./datails.vue?vue&type=script&lang=js&"
export * from "./datails.vue?vue&type=script&lang=js&"
import style0 from "./datails.vue?vue&type=style&index=0&id=5c989f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c989f28",
  null
  
)

export default component.exports